// Equipment options for profile setup

export const equipmentCategories = [
  {
    category: 'Free Weights',
    items: [
      { id: 'barbell', name: 'Barbell' },
      { id: 'dumbbells', name: 'Dumbbells' },
      { id: 'kettlebell', name: 'Kettlebell' },
      { id: 'ez-bar', name: 'EZ Curl Bar' },
      { id: 'trap-bar', name: 'Trap / Hex Bar' },
      { id: 'weight-plates', name: 'Weight Plates' },
      { id: 'plate', name: 'Single Plate (for plate-loaded movements)' },
      { id: 'blocks', name: 'Lifting Blocks (Olympic lifting risers)' },
    ],
  },
  {
    category: 'Benches & Racks',
    items: [
      { id: 'flat-bench', name: 'Flat Bench' },
      { id: 'incline-bench', name: 'Adjustable Bench' },
      { id: 'squat-rack', name: 'Squat Rack / Power Rack' },
      { id: 'smith-machine', name: 'Smith Machine' },
      { id: 'preacher-bench', name: 'Preacher Bench' },
    ],
  },
  {
    category: 'Machines',
    items: [
      { id: 'cable', name: 'Cable Machine' },
      { id: 'leg-press', name: 'Leg Press' },
      { id: 'hack-squat', name: 'Hack Squat' },
      { id: 'lat-pulldown', name: 'Lat Pulldown' },
      { id: 'seated-row', name: 'Seated Row Machine' },
      { id: 'leg-curl', name: 'Leg Curl Machine' },
      { id: 'leg-extension', name: 'Leg Extension' },
      { id: 'chest-press', name: 'Chest Press Machine' },
      { id: 'calf-raise-machine', name: 'Calf Raise (Standing/Seated)' },
      { id: 'glute-ham-developer', name: 'Glute-Ham Developer (GHD)' },
      { id: 'belt-squat-machine', name: 'Belt Squat Machine (advanced / commercial gym)' },
      { id: 't-bar-row', name: 'T-Bar / Landmine Row' },
      { id: 'machine', name: 'Commercial gym (other machines)', desc: 'Generic catch-all if you have full gym access.' },
    ],
  },
  {
    category: 'Bodyweight & Accessories',
    items: [
      { id: 'pullup-bar', name: 'Pull-up Bar' },
      { id: 'dip-bar', name: 'Dip Bar / Station' },
      { id: 'rings', name: 'Gymnastic Rings' },
      { id: 'parallettes', name: 'Parallettes / Push-up Bars' },
      { id: 'trx', name: 'TRX / Suspension Trainer' },
      { id: 'bands', name: 'Resistance Bands' },
      { id: 'med-ball', name: 'Medicine Ball' },
      { id: 'stability-ball', name: 'Stability Ball' },
      { id: 'foam-roller', name: 'Foam Roller' },
      { id: 'plyo-box', name: 'Plyo Box' },
      { id: 'step', name: 'Step / Aerobic Box' },
      { id: 'towel', name: 'Towel (for pull-up grip)' },
      { id: 'fat-grips', name: 'Fat Gripz' },
      { id: 'gripper', name: 'Captains of Crush / Gripper' },
      { id: 'ab-wheel', name: 'Ab Wheel' },
      { id: 'mini-band', name: 'Mini Loop Band (glute/clamshell)' },
      { id: 'sliders', name: 'Furniture Sliders / Valslides' },
      { id: 'wrist-roller', name: 'Wrist Roller' },
      { id: 'therapy-ball', name: 'Therapy Putty / Stress Ball (rehab grip)' },
      { id: 'light-dumbbells', name: 'Light Dumbbells (2-5 lb, rehab)' },
    ],
  },
  {
    category: 'Specialty Benches',
    items: [
      { id: 'back-extension-bench', name: '45° Back Extension Bench / Hyperextension' },
    ],
  },
  {
    category: 'Strongman / Implements',
    desc: 'Specialty implements — most live in commercial / strongman gyms.',
    items: [
      { id: 'sandbag', name: 'Sandbag (50-200 lb)' },
      { id: 'sled', name: 'Sled / Prowler' },
      { id: 'yoke', name: 'Yoke / Frame' },
      { id: 'log-bar', name: 'Log Bar' },
      { id: 'atlas-stones', name: 'Atlas Stones' },
      { id: 'farmers-handles', name: 'Farmer\'s Walk Handles' },
    ],
  },
  {
    category: 'Cardio',
    items: [
      { id: 'treadmill', name: 'Treadmill' },
      { id: 'stationary-bike', name: 'Stationary / Connected Bike' },
      { id: 'rower', name: 'Rowing Machine' },
      { id: 'ski-erg', name: 'Ski Erg' },
      { id: 'elliptical-max', name: 'Elliptical / Max Trainer™' },
      { id: 'stair-climber', name: 'Stair Climber' },
      { id: 'jump-rope', name: 'Jump Rope' },
      { id: 'heavy-bag', name: 'Heavy Bag' },
      { id: 'assault-bike', name: 'Assault / Air Bike' },
      { id: 'battle-ropes', name: 'Battle Ropes' },
      { id: 'medicine-ball', name: 'Medicine Ball / Slam Ball' },
      { id: 'rattan-stick', name: 'Rattan Sticks (Kali / Eskrima)' },
      { id: 'pool', name: 'Pool / Water' },
      { id: 'indoor-track', name: 'Indoor Track' },
    ],
  },
];

// Alphabetize items within each category so the picker is scannable (category
// grouping preserved; only within-group order changes). One source of truth — every
// consumer (onboarding, profile editor, add-exercise sheet) inherits the order.
equipmentCategories.forEach((c) => c.items.sort((a, b) => a.name.localeCompare(b.name)));

export const allEquipmentIds = equipmentCategories.flatMap((c) => c.items.map((i) => i.id));

export const injuryRegions = [
  { id: 'back', name: 'Back / Spine' },
  { id: 'neck', name: 'Neck' },
  { id: 'shoulders', name: 'Shoulders' },
  { id: 'elbows', name: 'Elbows' },
  { id: 'wrists', name: 'Wrists' },
  { id: 'hips', name: 'Hips' },
  { id: 'knees', name: 'Knees' },
  { id: 'ankles', name: 'Ankles / Feet' },
];

export const injurySystemic = [
  { id: 'heart', name: 'Heart / Cardiovascular' },
  { id: 'asthma', name: 'Asthma / Respiratory' },
  { id: 'pregnancy', name: 'Pregnancy' },
  { id: 'post-surgery', name: 'Recovering from Surgery' },
  { id: 'hypertension', name: 'High Blood Pressure' },
];

export const goalOptions = [
  { id: 'strength', name: 'Build Strength', desc: 'Heavy compound lifts, lower reps.' },
  { id: 'muscle', name: 'Build Muscle', desc: 'Hypertrophy focus, moderate reps.' },
  { id: 'endurance', name: 'Endurance', desc: 'Stamina, high-rep circuits, cardio.' },
  { id: 'combatives', name: 'Train Combatives', desc: 'Martial arts, BJJ, boxing, MMA — tracked separately from strength.' },
  { id: 'fat-loss', name: 'Fat Loss', desc: 'Calorie burn, metabolic conditioning.' },
  { id: 'health', name: 'General Health', desc: 'Balanced, sustainable fitness.' },
  { id: 'recovery', name: 'Recovery & Mobility', desc: 'Rehab, joint health, flexibility.' },
];

export const experienceLevels = [
  { id: 'beginner', name: 'Beginner', desc: 'New to training or returning after a long break.' },
  { id: 'intermediate', name: 'Intermediate', desc: '6+ months of consistent training. Know the basics.' },
  { id: 'advanced', name: 'Advanced', desc: '2+ years lifting. Comfortable with complex movements.' },
];
